var render = function render(){var _vm=this,_c=_vm._self._c;return _c('auth-container',{attrs:{"page":_vm.page}},[_c('h2',{staticClass:"mb-4"},[_vm._v("Create New Project")]),_c('sr-project-form',{attrs:{"item":_vm.item,"application":_vm.application,"set-options":_vm.setOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }